//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the availability of the advanced export for the current workbook/view for the current user.
     * @param body (optional) 
     * @return OK
     */
    apiAdvancedExportIntegrationAvailability(body?: AdvancedExportIntegrationAvailabilityRequestDTO | undefined): Promise<AdvancedExportIntegrationAvailabilityDTO> {
        let url_ = this.baseUrl + "/api/advanced-export/integration/availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdvancedExportIntegrationAvailability(_response);
        });
    }

    protected processApiAdvancedExportIntegrationAvailability(response: Response): Promise<AdvancedExportIntegrationAvailabilityDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdvancedExportIntegrationAvailabilityDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdvancedExportIntegrationAvailabilityDTO>(null as any);
    }

    /**
     * Creates an image/PDF job of the specified workbook with the config. Returns the status of the job
     * @param body (optional) 
     * @return OK
     */
    apiAdvancedExportIntegrationGenerateStart(body?: AdvancedExportGenerateRequestDTO | undefined): Promise<ErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO> {
        let url_ = this.baseUrl + "/api/advanced-export/integration/generate/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdvancedExportIntegrationGenerateStart(_response);
        });
    }

    protected processApiAdvancedExportIntegrationGenerateStart(response: Response): Promise<ErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO>(null as any);
    }

    /**
     * Returns the status of a generate job
     * @param runId (optional) 
     * @return OK
     */
    apiAdvancedExportIntegrationGenerateStatus(runId?: string | undefined): Promise<ErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO> {
        let url_ = this.baseUrl + "/api/advanced-export/integration/generate/status?";
        if (runId === null)
            throw new Error("The parameter 'runId' cannot be null.");
        else if (runId !== undefined)
            url_ += "runId=" + encodeURIComponent("" + runId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdvancedExportIntegrationGenerateStatus(_response);
        });
    }

    protected processApiAdvancedExportIntegrationGenerateStatus(response: Response): Promise<ErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO>(null as any);
    }

    /**
     * Downloads the output of a generate job. Only called when job status is 'success'
     * @param runId (optional) 
     * @return OK
     */
    apiAdvancedExportIntegrationGenerateDownload(runId?: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/advanced-export/integration/generate/download?";
        if (runId === null)
            throw new Error("The parameter 'runId' cannot be null.");
        else if (runId !== undefined)
            url_ += "runId=" + encodeURIComponent("" + runId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "image/png"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdvancedExportIntegrationGenerateDownload(_response);
        });
    }

    protected processApiAdvancedExportIntegrationGenerateDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Cancels the generate job
     * @param runId (optional) 
     * @return OK
     */
    apiAdvancedExportIntegrationGenerateCancel(runId?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/advanced-export/integration/generate/cancel?";
        if (runId === null)
            throw new Error("The parameter 'runId' cannot be null.");
        else if (runId !== undefined)
            url_ += "runId=" + encodeURIComponent("" + runId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdvancedExportIntegrationGenerateCancel(_response);
        });
    }

    protected processApiAdvancedExportIntegrationGenerateCancel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the available roles for a logged in user on a Tableau Server on a site. Requires Tableau session
     * @param body (optional) 
     * @return OK
     */
    apiChangeRoleTableauIntegrationGetAvailableRoles(body?: ChangeRoleInfoRequestDTO | undefined): Promise<ChangeRoleResponseDTO> {
        let url_ = this.baseUrl + "/api/change-role/tableau-integration/get-available-roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiChangeRoleTableauIntegrationGetAvailableRoles(_response);
        });
    }

    protected processApiChangeRoleTableauIntegrationGetAvailableRoles(response: Response): Promise<ChangeRoleResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRoleResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRoleResponseDTO>(null as any);
    }

    /**
     * Changes the role of a logged in user on a Tableau Server on a site. Requires Tableau session
     * @param body (optional) 
     * @return OK
     */
    apiChangeRoleTableauIntegrationChangeRole(body?: ChangeRoleRequestDTO | undefined): Promise<ChangeRoleResponseDTO> {
        let url_ = this.baseUrl + "/api/change-role/tableau-integration/change-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiChangeRoleTableauIntegrationChangeRole(_response);
        });
    }

    protected processApiChangeRoleTableauIntegrationChangeRole(response: Response): Promise<ChangeRoleResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRoleResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRoleResponseDTO>(null as any);
    }

    /**
     * Checks the integration button info.
     * @param body (optional) 
     * @return OK
     */
    apiEmailIntegrationButtonInfo(body?: EmailButtonInputDTO | undefined): Promise<EmailButtonInfoDTO> {
        let url_ = this.baseUrl + "/api/email-integration-button/info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiEmailIntegrationButtonInfo(_response);
        });
    }

    protected processApiEmailIntegrationButtonInfo(response: Response): Promise<EmailButtonInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailButtonInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailButtonInfoDTO>(null as any);
    }

    /**
     * Sends an email
     * @param body (optional) 
     * @return OK
     */
    apiEmailIntegrationButtonSendEmail(body?: EmailInputDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/email-integration-button/send-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiEmailIntegrationButtonSendEmail(_response);
        });
    }

    protected processApiEmailIntegrationButtonSendEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the OAuth URL for Google Sheets
     * @param baseUrl (optional) 
     * @return OK
     */
    apiGoogleSheetOauth(baseUrl?: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/google-sheet/oauth?";
        if (baseUrl === null)
            throw new Error("The parameter 'baseUrl' cannot be null.");
        else if (baseUrl !== undefined)
            url_ += "baseUrl=" + encodeURIComponent("" + baseUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiGoogleSheetOauth(_response);
        });
    }

    protected processApiGoogleSheetOauth(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * NOT AN API ENDPOINT. Called by Google Oauth callback.
     * @param code (optional) 
     * @param state (optional) 
     * @return OK
     */
    apiGoogleSheetOauthCallbackGoogle(code?: string | undefined, state?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/google-sheet/oauth/callback/google?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiGoogleSheetOauthCallbackGoogle(_response);
        });
    }

    protected processApiGoogleSheetOauthCallbackGoogle(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param tokenKey (optional) 
     * @return OK
     */
    apiGoogleSheetOauthCallbackPlaceToken(tokenKey?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/google-sheet/oauth/callback/place-token?";
        if (tokenKey === null)
            throw new Error("The parameter 'tokenKey' cannot be null.");
        else if (tokenKey !== undefined)
            url_ += "tokenKey=" + encodeURIComponent("" + tokenKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiGoogleSheetOauthCallbackPlaceToken(_response);
        });
    }

    protected processApiGoogleSheetOauthCallbackPlaceToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the Google login information based on a token key
     * @return OK
     */
    apiGoogleSheetOauthInfo(): Promise<TokenInfoDTO> {
        let url_ = this.baseUrl + "/api/google-sheet/oauth/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiGoogleSheetOauthInfo(_response);
        });
    }

    protected processApiGoogleSheetOauthInfo(response: Response): Promise<TokenInfoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenInfoDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenInfoDTO>(null as any);
    }

    /**
     * @return OK
     */
    apiGoogleSheetOauthLogout(): Promise<void> {
        let url_ = this.baseUrl + "/api/google-sheet/oauth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiGoogleSheetOauthLogout(_response);
        });
    }

    protected processApiGoogleSheetOauthLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Checks the integration button info. Requires Tableau session
     * @param body (optional) 
     * @return OK
     */
    apiGoogleSheetInfo(body?: SpreadSheetEnabledInputInfoDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/google-sheet/info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiGoogleSheetInfo(_response);
        });
    }

    protected processApiGoogleSheetInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Queries all spreadsheet from the authenticated user's drive. Requires Tableau session
     * @param body (optional) 
     * @return OK
     */
    apiGoogleSheetList(body?: SpreadSheetListRequestDTO | undefined): Promise<SpreadSheetResponseDTO[]> {
        let url_ = this.baseUrl + "/api/google-sheet/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiGoogleSheetList(_response);
        });
    }

    protected processApiGoogleSheetList(response: Response): Promise<SpreadSheetResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpreadSheetResponseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpreadSheetResponseDTO[]>(null as any);
    }

    /**
     * Creates a new google spreadsheet. Requires Tableau session
     * @param body (optional) 
     * @return OK
     */
    apiGoogleSheetCreate(body?: CreateSpreadSheetRequestDTO | undefined): Promise<UpdateSpreadSheetDataResponseDTO> {
        let url_ = this.baseUrl + "/api/google-sheet/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiGoogleSheetCreate(_response);
        });
    }

    protected processApiGoogleSheetCreate(response: Response): Promise<UpdateSpreadSheetDataResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSpreadSheetDataResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateSpreadSheetDataResponseDTO>(null as any);
    }

    /**
     * Updates a google spreadsheet. Requires Tableau session
     * @param body (optional) 
     * @return OK
     */
    apiGoogleSheetUpdate(body?: UpdateSpreadSheetRequestDTO | undefined): Promise<UpdateSpreadSheetDataResponseDTO> {
        let url_ = this.baseUrl + "/api/google-sheet/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiGoogleSheetUpdate(_response);
        });
    }

    protected processApiGoogleSheetUpdate(response: Response): Promise<UpdateSpreadSheetDataResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSpreadSheetDataResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateSpreadSheetDataResponseDTO>(null as any);
    }

    /**
     * Get Available Roles
     * @param body (optional) 
     * @return OK
     */
    apiCustomNxTableauIntegrationGetRoles(body?: ChangeRoleInfoRequestDTO | undefined): Promise<ChangeRoleResponseDTO> {
        let url_ = this.baseUrl + "/api/custom/nx/tableau-integration/get-roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiCustomNxTableauIntegrationGetRoles(_response);
        });
    }

    protected processApiCustomNxTableauIntegrationGetRoles(response: Response): Promise<ChangeRoleResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRoleResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRoleResponseDTO>(null as any);
    }

    /**
     * Change Role
     * @param body (optional) 
     * @return OK
     */
    apiCustomNxTableauIntegrationChangeRole(body?: ChangeRoleRequestDTO | undefined): Promise<ChangeRoleResponseDTO> {
        let url_ = this.baseUrl + "/api/custom/nx/tableau-integration/change-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiCustomNxTableauIntegrationChangeRole(_response);
        });
    }

    protected processApiCustomNxTableauIntegrationChangeRole(response: Response): Promise<ChangeRoleResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRoleResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRoleResponseDTO>(null as any);
    }

    /**
     * Get WalkMe script
     * @param serverId (optional) 
     * @return OK
     */
    apiCustomNxTableauIntegrationWalkmeScript(serverId?: string | undefined): Promise<WalkMeScriptDTO> {
        let url_ = this.baseUrl + "/api/custom/nx/tableau-integration/walkme-script?";
        if (serverId === null)
            throw new Error("The parameter 'serverId' cannot be null.");
        else if (serverId !== undefined)
            url_ += "serverId=" + encodeURIComponent("" + serverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiCustomNxTableauIntegrationWalkmeScript(_response);
        });
    }

    protected processApiCustomNxTableauIntegrationWalkmeScript(response: Response): Promise<WalkMeScriptDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalkMeScriptDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalkMeScriptDTO>(null as any);
    }

    /**
     * Called by integration JS when Tableau Login fails with unlicensed error. Returns sites user is disabled on with reactivation options
     * @param body (optional) 
     * @return OK
     */
    apiReactivationInternalCheckReactivation(body?: UnlicensedSitesInputDTO | undefined): Promise<UnlicensedSitesResponseDTO> {
        let url_ = this.baseUrl + "/api/reactivation-internal/check-reactivation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiReactivationInternalCheckReactivation(_response);
        });
    }

    protected processApiReactivationInternalCheckReactivation(response: Response): Promise<UnlicensedSitesResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnlicensedSitesResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnlicensedSitesResponseDTO>(null as any);
    }

    /**
     * Called by integration JS. Reactivates user self service
     * @param body (optional) 
     * @return OK
     */
    apiReactivationInternalReactivateSelfService(body?: SelfServiceReactivateInputDTO | undefined): Promise<ReactivateResponseDTO> {
        let url_ = this.baseUrl + "/api/reactivation-internal/reactivate/self-service";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiReactivationInternalReactivateSelfService(_response);
        });
    }

    protected processApiReactivationInternalReactivateSelfService(response: Response): Promise<ReactivateResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReactivateResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReactivateResponseDTO>(null as any);
    }

    /**
     * Called by integration JS. Requests reactivation of user
     * @param body (optional) 
     * @return OK
     */
    apiReactivationInternalReactivateRequest(body?: ReactivationRequestInputDTO | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/reactivation-internal/reactivate/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiReactivationInternalReactivateRequest(_response);
        });
    }

    protected processApiReactivationInternalReactivateRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Queries responsible ad group for resource. Requires Tableau session
     * @param body (optional) 
     * @return OK
     */
    apiRequestAccessTableauIntegrationRequestAccess(body?: RequestAccessRequestDTO | undefined): Promise<RequestAccessResponseDTO> {
        let url_ = this.baseUrl + "/api/request-access/tableau-integration/request-access";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiRequestAccessTableauIntegrationRequestAccess(_response);
        });
    }

    protected processApiRequestAccessTableauIntegrationRequestAccess(response: Response): Promise<RequestAccessResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestAccessResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestAccessResponseDTO>(null as any);
    }

    /**
     * Returns the relevant alerts for the current Tableau Session. (works with or without tableau session)
     * @param serverId (optional) 
     * @param isFromEmbed (optional) 
     * @return OK
     */
    apiTableauServerAlertsClientGetAlerts(serverId?: string | undefined, isFromEmbed?: boolean | undefined): Promise<RelevantAlertsDTO> {
        let url_ = this.baseUrl + "/api/tableau-server-alerts/client/get-alerts?";
        if (serverId === null)
            throw new Error("The parameter 'serverId' cannot be null.");
        else if (serverId !== undefined)
            url_ += "serverId=" + encodeURIComponent("" + serverId) + "&";
        if (isFromEmbed === null)
            throw new Error("The parameter 'isFromEmbed' cannot be null.");
        else if (isFromEmbed !== undefined)
            url_ += "isFromEmbed=" + encodeURIComponent("" + isFromEmbed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTableauServerAlertsClientGetAlerts(_response);
        });
    }

    protected processApiTableauServerAlertsClientGetAlerts(response: Response): Promise<RelevantAlertsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelevantAlertsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelevantAlertsDTO>(null as any);
    }

    /**
     * Dismisses an alert. This can only be called with a valid tableau session
     * @param alertId (optional) 
     * @return OK
     */
    apiTableauServerAlertsClientDismiss(alertId?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/tableau-server-alerts/client/dismiss?";
        if (alertId === null)
            throw new Error("The parameter 'alertId' cannot be null.");
        else if (alertId !== undefined)
            url_ += "alertId=" + encodeURIComponent("" + alertId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTableauServerAlertsClientDismiss(_response);
        });
    }

    protected processApiTableauServerAlertsClientDismiss(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Stores alert statistics. Can be called with / without tableau session
     * @param serverId (optional) 
     * @param body (optional) 
     * @return OK
     */
    apiTableauServerAlertsClientStoreStatistics(serverId?: string | undefined, body?: ServerAlertStatisticInputDTO[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/tableau-server-alerts/client/store-statistics?";
        if (serverId === null)
            throw new Error("The parameter 'serverId' cannot be null.");
        else if (serverId !== undefined)
            url_ += "serverId=" + encodeURIComponent("" + serverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTableauServerAlertsClientStoreStatistics(_response);
        });
    }

    protected processApiTableauServerAlertsClientStoreStatistics(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    apiTableauIntegrationLoading(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/tableau-integration/loading";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/html"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTableauIntegrationLoading(_response);
        });
    }

    protected processApiTableauIntegrationLoading(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    apiTableauIntegrationUnlicensedSites(body?: UnlicensedSitesResponseDTO | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/tableau-integration/unlicensed-sites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/html"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTableauIntegrationUnlicensedSites(_response);
        });
    }

    protected processApiTableauIntegrationUnlicensedSites(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    apiTableauIntegrationRequestAccess(body?: RequestAccessResponseDTO | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/tableau-integration/request-access";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/html"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTableauIntegrationRequestAccess(_response);
        });
    }

    protected processApiTableauIntegrationRequestAccess(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorTypesErrorResponseDTO.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AdvancedExportConfigTableauResourceDTO implements IAdvancedExportConfigTableauResourceDTO {
    id?: number;
    name?: string | undefined;
    parent_Project?: AdvancedExportConfigTableauResourceDTO;
    parent_Site?: AdvancedExportConfigTableauResourceDTO;
    parent_Workbook?: AdvancedExportConfigTableauResourceDTO;

    constructor(data?: IAdvancedExportConfigTableauResourceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parent_Project = _data["parent_Project"] ? AdvancedExportConfigTableauResourceDTO.fromJS(_data["parent_Project"]) : <any>undefined;
            this.parent_Site = _data["parent_Site"] ? AdvancedExportConfigTableauResourceDTO.fromJS(_data["parent_Site"]) : <any>undefined;
            this.parent_Workbook = _data["parent_Workbook"] ? AdvancedExportConfigTableauResourceDTO.fromJS(_data["parent_Workbook"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdvancedExportConfigTableauResourceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedExportConfigTableauResourceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parent_Project"] = this.parent_Project ? this.parent_Project.toJSON() : <any>undefined;
        data["parent_Site"] = this.parent_Site ? this.parent_Site.toJSON() : <any>undefined;
        data["parent_Workbook"] = this.parent_Workbook ? this.parent_Workbook.toJSON() : <any>undefined;
        return data;
    }

    clone(): AdvancedExportConfigTableauResourceDTO {
        const json = this.toJSON();
        let result = new AdvancedExportConfigTableauResourceDTO();
        result.init(json);
        return result;
    }
}

export interface IAdvancedExportConfigTableauResourceDTO {
    id?: number;
    name?: string | undefined;
    parent_Project?: AdvancedExportConfigTableauResourceDTO;
    parent_Site?: AdvancedExportConfigTableauResourceDTO;
    parent_Workbook?: AdvancedExportConfigTableauResourceDTO;
}

export class AdvancedExportGenerateFilterInfoDTO implements IAdvancedExportGenerateFilterInfoDTO {
    name!: string;
    value!: string;

    constructor(data?: IAdvancedExportGenerateFilterInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): AdvancedExportGenerateFilterInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedExportGenerateFilterInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): AdvancedExportGenerateFilterInfoDTO {
        const json = this.toJSON();
        let result = new AdvancedExportGenerateFilterInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IAdvancedExportGenerateFilterInfoDTO {
    name: string;
    value: string;
}

export class AdvancedExportGenerateIterationFilterInfoDTO implements IAdvancedExportGenerateIterationFilterInfoDTO {
    name!: string;
    values!: string[];

    constructor(data?: IAdvancedExportGenerateIterationFilterInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.values = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): AdvancedExportGenerateIterationFilterInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedExportGenerateIterationFilterInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }

    clone(): AdvancedExportGenerateIterationFilterInfoDTO {
        const json = this.toJSON();
        let result = new AdvancedExportGenerateIterationFilterInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IAdvancedExportGenerateIterationFilterInfoDTO {
    name: string;
    values: string[];
}

export class AdvancedExportGenerateRequestDTO implements IAdvancedExportGenerateRequestDTO {
    workbookId!: number;
    viewIds!: number[];
    filters?: AdvancedExportGenerateFilterInfoDTO[] | undefined;
    iterationFilter?: AdvancedExportGenerateIterationFilterInfoDTO;
    outputType!: AdvancedExportOutputType;
    pdfOrientation!: Orientation;
    pdfSize!: PageType;
    pdfMergeViews!: boolean;
    pdfMergeIterationFilters!: boolean;
    serverId!: string;

    constructor(data?: IAdvancedExportGenerateRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.viewIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookId = _data["workbookId"];
            if (Array.isArray(_data["viewIds"])) {
                this.viewIds = [] as any;
                for (let item of _data["viewIds"])
                    this.viewIds!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(AdvancedExportGenerateFilterInfoDTO.fromJS(item));
            }
            this.iterationFilter = _data["iterationFilter"] ? AdvancedExportGenerateIterationFilterInfoDTO.fromJS(_data["iterationFilter"]) : <any>undefined;
            this.outputType = _data["outputType"];
            this.pdfOrientation = _data["pdfOrientation"];
            this.pdfSize = _data["pdfSize"];
            this.pdfMergeViews = _data["pdfMergeViews"];
            this.pdfMergeIterationFilters = _data["pdfMergeIterationFilters"];
            this.serverId = _data["serverId"];
        }
    }

    static fromJS(data: any): AdvancedExportGenerateRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedExportGenerateRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookId"] = this.workbookId;
        if (Array.isArray(this.viewIds)) {
            data["viewIds"] = [];
            for (let item of this.viewIds)
                data["viewIds"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["iterationFilter"] = this.iterationFilter ? this.iterationFilter.toJSON() : <any>undefined;
        data["outputType"] = this.outputType;
        data["pdfOrientation"] = this.pdfOrientation;
        data["pdfSize"] = this.pdfSize;
        data["pdfMergeViews"] = this.pdfMergeViews;
        data["pdfMergeIterationFilters"] = this.pdfMergeIterationFilters;
        data["serverId"] = this.serverId;
        return data;
    }

    clone(): AdvancedExportGenerateRequestDTO {
        const json = this.toJSON();
        let result = new AdvancedExportGenerateRequestDTO();
        result.init(json);
        return result;
    }
}

export interface IAdvancedExportGenerateRequestDTO {
    workbookId: number;
    viewIds: number[];
    filters?: AdvancedExportGenerateFilterInfoDTO[] | undefined;
    iterationFilter?: AdvancedExportGenerateIterationFilterInfoDTO;
    outputType: AdvancedExportOutputType;
    pdfOrientation: Orientation;
    pdfSize: PageType;
    pdfMergeViews: boolean;
    pdfMergeIterationFilters: boolean;
    serverId: string;
}

export class AdvancedExportGenerateRequestInternal implements IAdvancedExportGenerateRequestInternal {
    workbookId!: number;
    viewIds!: number[];
    filters?: AdvancedExportGenerateFilterInfoDTO[] | undefined;
    iterationFilter?: AdvancedExportGenerateIterationFilterInfoDTO;
    outputType!: AdvancedExportOutputType;
    pdfOrientation!: Orientation;
    pdfSize!: PageType;
    pdfMergeViews!: boolean;
    pdfMergeIterationFilters!: boolean;

    constructor(data?: IAdvancedExportGenerateRequestInternal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.viewIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workbookId = _data["workbookId"];
            if (Array.isArray(_data["viewIds"])) {
                this.viewIds = [] as any;
                for (let item of _data["viewIds"])
                    this.viewIds!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(AdvancedExportGenerateFilterInfoDTO.fromJS(item));
            }
            this.iterationFilter = _data["iterationFilter"] ? AdvancedExportGenerateIterationFilterInfoDTO.fromJS(_data["iterationFilter"]) : <any>undefined;
            this.outputType = _data["outputType"];
            this.pdfOrientation = _data["pdfOrientation"];
            this.pdfSize = _data["pdfSize"];
            this.pdfMergeViews = _data["pdfMergeViews"];
            this.pdfMergeIterationFilters = _data["pdfMergeIterationFilters"];
        }
    }

    static fromJS(data: any): AdvancedExportGenerateRequestInternal {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedExportGenerateRequestInternal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workbookId"] = this.workbookId;
        if (Array.isArray(this.viewIds)) {
            data["viewIds"] = [];
            for (let item of this.viewIds)
                data["viewIds"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["iterationFilter"] = this.iterationFilter ? this.iterationFilter.toJSON() : <any>undefined;
        data["outputType"] = this.outputType;
        data["pdfOrientation"] = this.pdfOrientation;
        data["pdfSize"] = this.pdfSize;
        data["pdfMergeViews"] = this.pdfMergeViews;
        data["pdfMergeIterationFilters"] = this.pdfMergeIterationFilters;
        return data;
    }

    clone(): AdvancedExportGenerateRequestInternal {
        const json = this.toJSON();
        let result = new AdvancedExportGenerateRequestInternal();
        result.init(json);
        return result;
    }
}

export interface IAdvancedExportGenerateRequestInternal {
    workbookId: number;
    viewIds: number[];
    filters?: AdvancedExportGenerateFilterInfoDTO[] | undefined;
    iterationFilter?: AdvancedExportGenerateIterationFilterInfoDTO;
    outputType: AdvancedExportOutputType;
    pdfOrientation: Orientation;
    pdfSize: PageType;
    pdfMergeViews: boolean;
    pdfMergeIterationFilters: boolean;
}

export class AdvancedExportIntegrationAvailabilityDTO implements IAdvancedExportIntegrationAvailabilityDTO {
    isAvailable?: boolean;
    views?: AdvancedExportConfigTableauResourceDTO[] | undefined;
    currentWorkbookId?: number;
    currentViewId?: number | undefined;

    constructor(data?: IAdvancedExportIntegrationAvailabilityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
            if (Array.isArray(_data["views"])) {
                this.views = [] as any;
                for (let item of _data["views"])
                    this.views!.push(AdvancedExportConfigTableauResourceDTO.fromJS(item));
            }
            this.currentWorkbookId = _data["currentWorkbookId"];
            this.currentViewId = _data["currentViewId"];
        }
    }

    static fromJS(data: any): AdvancedExportIntegrationAvailabilityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedExportIntegrationAvailabilityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        if (Array.isArray(this.views)) {
            data["views"] = [];
            for (let item of this.views)
                data["views"].push(item.toJSON());
        }
        data["currentWorkbookId"] = this.currentWorkbookId;
        data["currentViewId"] = this.currentViewId;
        return data;
    }

    clone(): AdvancedExportIntegrationAvailabilityDTO {
        const json = this.toJSON();
        let result = new AdvancedExportIntegrationAvailabilityDTO();
        result.init(json);
        return result;
    }
}

export interface IAdvancedExportIntegrationAvailabilityDTO {
    isAvailable?: boolean;
    views?: AdvancedExportConfigTableauResourceDTO[] | undefined;
    currentWorkbookId?: number;
    currentViewId?: number | undefined;
}

export class AdvancedExportIntegrationAvailabilityRequestDTO implements IAdvancedExportIntegrationAvailabilityRequestDTO {
    serverId!: string;
    workbookUrl!: string;
    viewUrl?: string | undefined;

    constructor(data?: IAdvancedExportIntegrationAvailabilityRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverId = _data["serverId"];
            this.workbookUrl = _data["workbookUrl"];
            this.viewUrl = _data["viewUrl"];
        }
    }

    static fromJS(data: any): AdvancedExportIntegrationAvailabilityRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedExportIntegrationAvailabilityRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverId"] = this.serverId;
        data["workbookUrl"] = this.workbookUrl;
        data["viewUrl"] = this.viewUrl;
        return data;
    }

    clone(): AdvancedExportIntegrationAvailabilityRequestDTO {
        const json = this.toJSON();
        let result = new AdvancedExportIntegrationAvailabilityRequestDTO();
        result.init(json);
        return result;
    }
}

export interface IAdvancedExportIntegrationAvailabilityRequestDTO {
    serverId: string;
    workbookUrl: string;
    viewUrl?: string | undefined;
}

export class AdvancedExportJobArguments implements IAdvancedExportJobArguments {
    serverData?: TableauServerDTO;
    tableauUserLuidToImpersonate?: string | undefined;
    tableauUserSiteIdToImpersonate?: number | undefined;
    reportToEmails?: string[] | undefined;
    input?: AdvancedExportGenerateRequestInternal;

    constructor(data?: IAdvancedExportJobArguments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverData = _data["serverData"] ? TableauServerDTO.fromJS(_data["serverData"]) : <any>undefined;
            this.tableauUserLuidToImpersonate = _data["tableauUserLuidToImpersonate"];
            this.tableauUserSiteIdToImpersonate = _data["tableauUserSiteIdToImpersonate"];
            if (Array.isArray(_data["reportToEmails"])) {
                this.reportToEmails = [] as any;
                for (let item of _data["reportToEmails"])
                    this.reportToEmails!.push(item);
            }
            this.input = _data["input"] ? AdvancedExportGenerateRequestInternal.fromJS(_data["input"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdvancedExportJobArguments {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedExportJobArguments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverData"] = this.serverData ? this.serverData.toJSON() : <any>undefined;
        data["tableauUserLuidToImpersonate"] = this.tableauUserLuidToImpersonate;
        data["tableauUserSiteIdToImpersonate"] = this.tableauUserSiteIdToImpersonate;
        if (Array.isArray(this.reportToEmails)) {
            data["reportToEmails"] = [];
            for (let item of this.reportToEmails)
                data["reportToEmails"].push(item);
        }
        data["input"] = this.input ? this.input.toJSON() : <any>undefined;
        return data;
    }

    clone(): AdvancedExportJobArguments {
        const json = this.toJSON();
        let result = new AdvancedExportJobArguments();
        result.init(json);
        return result;
    }
}

export interface IAdvancedExportJobArguments {
    serverData?: TableauServerDTO;
    tableauUserLuidToImpersonate?: string | undefined;
    tableauUserSiteIdToImpersonate?: number | undefined;
    reportToEmails?: string[] | undefined;
    input?: AdvancedExportGenerateRequestInternal;
}

export class AdvancedExportJobResult implements IAdvancedExportJobResult {
    progressMessage?: string | undefined;
    fileMime?: string | undefined;
    fileName?: string | undefined;
    times?: { [key: string]: number; } | undefined;

    constructor(data?: IAdvancedExportJobResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.progressMessage = _data["progressMessage"];
            this.fileMime = _data["fileMime"];
            this.fileName = _data["fileName"];
            if (_data["times"]) {
                this.times = {} as any;
                for (let key in _data["times"]) {
                    if (_data["times"].hasOwnProperty(key))
                        (<any>this.times)![key] = _data["times"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdvancedExportJobResult {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedExportJobResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["progressMessage"] = this.progressMessage;
        data["fileMime"] = this.fileMime;
        data["fileName"] = this.fileName;
        if (this.times) {
            data["times"] = {};
            for (let key in this.times) {
                if (this.times.hasOwnProperty(key))
                    (<any>data["times"])[key] = (<any>this.times)[key];
            }
        }
        return data;
    }

    clone(): AdvancedExportJobResult {
        const json = this.toJSON();
        let result = new AdvancedExportJobResult();
        result.init(json);
        return result;
    }
}

export interface IAdvancedExportJobResult {
    progressMessage?: string | undefined;
    fileMime?: string | undefined;
    fileName?: string | undefined;
    times?: { [key: string]: number; } | undefined;
}

export enum AdvancedExportOutputType {
    Image = "image",
    Pdf = "pdf",
}

export class ChangeRoleInfoRequestDTO implements IChangeRoleInfoRequestDTO {
    serverId!: string;

    constructor(data?: IChangeRoleInfoRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverId = _data["serverId"];
        }
    }

    static fromJS(data: any): ChangeRoleInfoRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRoleInfoRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverId"] = this.serverId;
        return data;
    }

    clone(): ChangeRoleInfoRequestDTO {
        const json = this.toJSON();
        let result = new ChangeRoleInfoRequestDTO();
        result.init(json);
        return result;
    }
}

export interface IChangeRoleInfoRequestDTO {
    serverId: string;
}

export class ChangeRoleRequestDTO implements IChangeRoleRequestDTO {
    serverId!: string;
    requestedRole?: SiteRoleType;

    constructor(data?: IChangeRoleRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverId = _data["serverId"];
            this.requestedRole = _data["requestedRole"];
        }
    }

    static fromJS(data: any): ChangeRoleRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRoleRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverId"] = this.serverId;
        data["requestedRole"] = this.requestedRole;
        return data;
    }

    clone(): ChangeRoleRequestDTO {
        const json = this.toJSON();
        let result = new ChangeRoleRequestDTO();
        result.init(json);
        return result;
    }
}

export interface IChangeRoleRequestDTO {
    serverId: string;
    requestedRole?: SiteRoleType;
}

export class ChangeRoleResponseDTO implements IChangeRoleResponseDTO {
    currentRole?: SiteRoleType;
    availableRoles?: SiteRoleType[] | undefined;
    siteId?: number;
    siteName?: string | undefined;

    constructor(data?: IChangeRoleResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentRole = _data["currentRole"];
            if (Array.isArray(_data["availableRoles"])) {
                this.availableRoles = [] as any;
                for (let item of _data["availableRoles"])
                    this.availableRoles!.push(item);
            }
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
        }
    }

    static fromJS(data: any): ChangeRoleResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRoleResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentRole"] = this.currentRole;
        if (Array.isArray(this.availableRoles)) {
            data["availableRoles"] = [];
            for (let item of this.availableRoles)
                data["availableRoles"].push(item);
        }
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        return data;
    }

    clone(): ChangeRoleResponseDTO {
        const json = this.toJSON();
        let result = new ChangeRoleResponseDTO();
        result.init(json);
        return result;
    }
}

export interface IChangeRoleResponseDTO {
    currentRole?: SiteRoleType;
    availableRoles?: SiteRoleType[] | undefined;
    siteId?: number;
    siteName?: string | undefined;
}

export class CreateSpreadSheetRequestDTO implements ICreateSpreadSheetRequestDTO {
    serverId!: string;
    fileName!: string;
    sheetName?: string | undefined;
    parentFolderId?: string | undefined;
    data!: string[][];

    constructor(data?: ICreateSpreadSheetRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverId = _data["serverId"];
            this.fileName = _data["fileName"];
            this.sheetName = _data["sheetName"];
            this.parentFolderId = _data["parentFolderId"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateSpreadSheetRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpreadSheetRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverId"] = this.serverId;
        data["fileName"] = this.fileName;
        data["sheetName"] = this.sheetName;
        data["parentFolderId"] = this.parentFolderId;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }

    clone(): CreateSpreadSheetRequestDTO {
        const json = this.toJSON();
        let result = new CreateSpreadSheetRequestDTO();
        result.init(json);
        return result;
    }
}

export interface ICreateSpreadSheetRequestDTO {
    serverId: string;
    fileName: string;
    sheetName?: string | undefined;
    parentFolderId?: string | undefined;
    data: string[][];
}

export enum DayOfWeek {
    Sunday = "sunday",
    Monday = "monday",
    Tuesday = "tuesday",
    Wednesday = "wednesday",
    Thursday = "thursday",
    Friday = "friday",
    Saturday = "saturday",
}

export class EmailButtonInfoDTO implements IEmailButtonInfoDTO {
    token?: string | undefined;
    fromName?: string | undefined;
    fromEmail?: string | undefined;
    toEmail?: string | undefined;
    allowEmailOverride?: boolean;

    constructor(data?: IEmailButtonInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.fromName = _data["fromName"];
            this.fromEmail = _data["fromEmail"];
            this.toEmail = _data["toEmail"];
            this.allowEmailOverride = _data["allowEmailOverride"];
        }
    }

    static fromJS(data: any): EmailButtonInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmailButtonInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["fromName"] = this.fromName;
        data["fromEmail"] = this.fromEmail;
        data["toEmail"] = this.toEmail;
        data["allowEmailOverride"] = this.allowEmailOverride;
        return data;
    }

    clone(): EmailButtonInfoDTO {
        const json = this.toJSON();
        let result = new EmailButtonInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IEmailButtonInfoDTO {
    token?: string | undefined;
    fromName?: string | undefined;
    fromEmail?: string | undefined;
    toEmail?: string | undefined;
    allowEmailOverride?: boolean;
}

export class EmailButtonInputDTO implements IEmailButtonInputDTO {
    serverId!: string;
    workbookUrl!: string;

    constructor(data?: IEmailButtonInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverId = _data["serverId"];
            this.workbookUrl = _data["workbookUrl"];
        }
    }

    static fromJS(data: any): EmailButtonInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmailButtonInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverId"] = this.serverId;
        data["workbookUrl"] = this.workbookUrl;
        return data;
    }

    clone(): EmailButtonInputDTO {
        const json = this.toJSON();
        let result = new EmailButtonInputDTO();
        result.init(json);
        return result;
    }
}

export interface IEmailButtonInputDTO {
    serverId: string;
    workbookUrl: string;
}

export class EmailInputDTO implements IEmailInputDTO {
    token?: string | undefined;
    subject!: string;
    body!: string;
    dashboardImage?: string | undefined;
    overrideRecipient?: string | undefined;
    overrideSender?: string | undefined;

    constructor(data?: IEmailInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.dashboardImage = _data["dashboardImage"];
            this.overrideRecipient = _data["overrideRecipient"];
            this.overrideSender = _data["overrideSender"];
        }
    }

    static fromJS(data: any): EmailInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmailInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["dashboardImage"] = this.dashboardImage;
        data["overrideRecipient"] = this.overrideRecipient;
        data["overrideSender"] = this.overrideSender;
        return data;
    }

    clone(): EmailInputDTO {
        const json = this.toJSON();
        let result = new EmailInputDTO();
        result.init(json);
        return result;
    }
}

export interface IEmailInputDTO {
    token?: string | undefined;
    subject: string;
    body: string;
    dashboardImage?: string | undefined;
    overrideRecipient?: string | undefined;
    overrideSender?: string | undefined;
}

export enum ErrorTypes {
    UnhandledError = "unhandledError",
    InvalidInput = "invalidInput",
    InvalidCredentials = "invalidCredentials",
    OAuthLoginError = "oAuthLoginError",
    LoginNotAllowed = "loginNotAllowed",
    ForbiddenAuthenticationType = "forbiddenAuthenticationType",
    AdServerDown = "adServerDown",
    AdUserNotFound = "adUserNotFound",
    UserHasNoPassword = "userHasNoPassword",
    AppleConnectCookieMissing = "appleConnectCookieMissing",
    AppleConnectValidationError = "appleConnectValidationError",
    AppleConnectUserMissingInLDAP = "appleConnectUserMissingInLDAP",
    TokenInvalid = "tokenInvalid",
    PatNameAlreadyExists = "patNameAlreadyExists",
    PatNotFound = "patNotFound",
    ActivePatCannotBeDeleted = "activePatCannotBeDeleted",
    InvalidRefreshToken = "invalidRefreshToken",
    TokenExpirationTooLarge = "tokenExpirationTooLarge",
    PatExpired = "patExpired",
    ProfileNotFound = "profileNotFound",
    UserAlreadySetUp = "userAlreadySetUp",
    PrincipalWithNameAlreadyExists = "principalWithNameAlreadyExists",
    PrincipalNotFound = "principalNotFound",
    MembershipNotFound = "membershipNotFound",
    AlreadyAMember = "alreadyAMember",
    ServerNotFound = "serverNotFound",
    ServerNotPatched = "serverNotPatched",
    TableauApiError = "tableauApiError",
    TableauPostgresError = "tableauPostgresError",
    TableauUserNotFound = "tableauUserNotFound",
    TableauGroupNotFound = "tableauGroupNotFound",
    TableauServerLicensesExceeded = "tableauServerLicensesExceeded",
    SelfServiceReactivationNotAllowed = "selfServiceReactivationNotAllowed",
    ReactivationRequestNotAllowed = "reactivationRequestNotAllowed",
    ReactivationRequestNotFound = "reactivationRequestNotFound",
    InvalidationRuleNotFound = "invalidationRuleNotFound",
    RuleStatusNotFound = "ruleStatusNotFound",
    ProjectNotFound = "projectNotFound",
    WorkbookNotFound = "workbookNotFound",
    EmailIntegrationDisabled = "emailIntegrationDisabled",
    SourceUserNotFound = "sourceUserNotFound",
    LoggedInUserEmailNotFound = "loggedInUserEmailNotFound",
    WorkbookUserEmailNotFound = "workbookUserEmailNotFound",
    EmailInfoTokenNotFound = "emailInfoTokenNotFound",
    LicenseError = "licenseError",
    LicenseFeatureDisabled = "licenseFeatureDisabled",
    TableauServerAlertNotFound = "tableauServerAlertNotFound",
    AdvancedExportBackgroundJobDefinitionNotFound = "advancedExportBackgroundJobDefinitionNotFound",
    StaleContentBackgroundJobDefinitionNotFound = "staleContentBackgroundJobDefinitionNotFound",
    FeedbackNotFound = "feedbackNotFound",
    NewStatusSameAsActual = "newStatusSameAsActual",
    FeedbackAlreadyForwarded = "feedbackAlreadyForwarded",
    FeedbackOptionTurnedOff = "feedbackOptionTurnedOff",
    Outdated = "outdated",
    SiteNotFound = "siteNotFound",
    WorkflowNotFound = "workflowNotFound",
    WorkflowAccessNotAllowed = "workflowAccessNotAllowed",
    WorkflowNameAlreadyExists = "workflowNameAlreadyExists",
    WorkflowValidationError = "workflowValidationError",
    WorkflowGraphValidationError = "workflowGraphValidationError",
    WorkflowRateLimitHit = "workflowRateLimitHit",
    WorkflowInvalidParameterJson = "workflowInvalidParameterJson",
    WorkflowTaskParameterError = "workflowTaskParameterError",
    WorkflowTaskParameterMissingError = "workflowTaskParameterMissingError",
    WorkflowRunNotFound = "workflowRunNotFound",
    WorkflowParameterSetNotFound = "workflowParameterSetNotFound",
    WorkflowParameterSetNoAccess = "workflowParameterSetNoAccess",
    TaskGroupNotFound = "taskGroupNotFound",
    TaskGroupNameAlreadyExists = "taskGroupNameAlreadyExists",
    AutoMigrationNotFound = "autoMigrationNotFound",
    SheetFileNotFound = "sheetFileNotFound",
    SheetIntegrationDisabled = "sheetIntegrationDisabled",
    GoogleDriveServiceInitFailed = "googleDriveServiceInitFailed",
    GoogleSheetsServiceInitFailed = "googleSheetsServiceInitFailed",
    SheetNotFoundInSpreadSheet = "sheetNotFoundInSpreadSheet",
    DefaultSheetNotFoundInSpreadSheet = "defaultSheetNotFoundInSpreadSheet",
    LogFilePathNotConfigured = "logFilePathNotConfigured",
    LogFilePathNotFound = "logFilePathNotFound",
    GoogleSheetTokenNotFound = "googleSheetTokenNotFound",
    MigrationTargetNotFound = "migrationTargetNotFound",
    MigrationTargetInvalidStatus = "migrationTargetInvalidStatus",
    MigrationTargetNameAlreadyExists = "migrationTargetNameAlreadyExists",
    MigrationTargetCommunicationError = "migrationTargetCommunicationError",
    FailedToCreateJwtKey = "failedToCreateJwtKey",
    ScheduleNameAlreadyExists = "scheduleNameAlreadyExists",
    ScheduleNotFound = "scheduleNotFound",
}

export class ErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO implements IErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO {
    id?: string;
    jobName?: string | undefined;
    status?: LongPollingJobStatus;
    started?: Date;
    ended?: Date | undefined;
    instanceId?: string | undefined;
    context?: AdvancedExportJobArguments;
    progress?: AdvancedExportJobResult;
    result?: AdvancedExportJobResult;
    error?: ErrorTypesErrorResponseDTO;

    constructor(data?: IErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobName = _data["jobName"];
            this.status = _data["status"];
            this.started = _data["started"] ? new Date(_data["started"].toString()) : <any>undefined;
            this.ended = _data["ended"] ? new Date(_data["ended"].toString()) : <any>undefined;
            this.instanceId = _data["instanceId"];
            this.context = _data["context"] ? AdvancedExportJobArguments.fromJS(_data["context"]) : <any>undefined;
            this.progress = _data["progress"] ? AdvancedExportJobResult.fromJS(_data["progress"]) : <any>undefined;
            this.result = _data["result"] ? AdvancedExportJobResult.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? ErrorTypesErrorResponseDTO.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobName"] = this.jobName;
        data["status"] = this.status;
        data["started"] = this.started ? this.started.toISOString() : <any>undefined;
        data["ended"] = this.ended ? this.ended.toISOString() : <any>undefined;
        data["instanceId"] = this.instanceId;
        data["context"] = this.context ? this.context.toJSON() : <any>undefined;
        data["progress"] = this.progress ? this.progress.toJSON() : <any>undefined;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }

    clone(): ErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO {
        const json = this.toJSON();
        let result = new ErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IErrorTypesAdvancedExportJobArgumentsAdvancedExportJobResultAdvancedExportJobResultLongPollingJobInfoDTO {
    id?: string;
    jobName?: string | undefined;
    status?: LongPollingJobStatus;
    started?: Date;
    ended?: Date | undefined;
    instanceId?: string | undefined;
    context?: AdvancedExportJobArguments;
    progress?: AdvancedExportJobResult;
    result?: AdvancedExportJobResult;
    error?: ErrorTypesErrorResponseDTO;
}

export class ErrorTypesErrorResponseDTO implements IErrorTypesErrorResponseDTO {
    requestId?: string | undefined;
    error?: ErrorTypes;
    message?: string | undefined;
    details?: any | undefined;

    constructor(data?: IErrorTypesErrorResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.error = _data["error"];
            this.message = _data["message"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): ErrorTypesErrorResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorTypesErrorResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["error"] = this.error;
        data["message"] = this.message;
        data["details"] = this.details;
        return data;
    }

    clone(): ErrorTypesErrorResponseDTO {
        const json = this.toJSON();
        let result = new ErrorTypesErrorResponseDTO();
        result.init(json);
        return result;
    }
}

export interface IErrorTypesErrorResponseDTO {
    requestId?: string | undefined;
    error?: ErrorTypes;
    message?: string | undefined;
    details?: any | undefined;
}

export enum LongPollingJobStatus {
    Running = "running",
    Success = "success",
    Error = "error",
    Canceled = "canceled",
    TimedOut = "timedOut",
}

export enum Orientation {
    Portrait = "portrait",
    Landscape = "landscape",
}

export enum PageType {
    Legal = "legal",
    A3 = "a3",
    A4 = "a4",
    A5 = "a5",
    B5 = "b5",
    Executive = "executive",
    Folio = "folio",
    Ledger = "ledger",
    Letter = "letter",
    Note = "note",
    Quarto = "quarto",
    Tabloid = "tabloid",
}

export enum ReactivateMode {
    Allow = "allow",
    Reject = "reject",
    RequestOnly = "requestOnly",
}

export class ReactivateResponseDTO implements IReactivateResponseDTO {
    response?: ReactivateResponseType;

    constructor(data?: IReactivateResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.response = _data["response"];
        }
    }

    static fromJS(data: any): ReactivateResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReactivateResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response;
        return data;
    }

    clone(): ReactivateResponseDTO {
        const json = this.toJSON();
        let result = new ReactivateResponseDTO();
        result.init(json);
        return result;
    }
}

export interface IReactivateResponseDTO {
    response?: ReactivateResponseType;
}

export enum ReactivateResponseType {
    Success = "success",
    LicensesExceeded = "licensesExceeded",
}

export class ReactivationRequestInputDTO implements IReactivationRequestInputDTO {
    username!: string;
    serverId!: string;
    siteId!: number;
    description?: string | undefined;

    constructor(data?: IReactivationRequestInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.serverId = _data["serverId"];
            this.siteId = _data["siteId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ReactivationRequestInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReactivationRequestInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["serverId"] = this.serverId;
        data["siteId"] = this.siteId;
        data["description"] = this.description;
        return data;
    }

    clone(): ReactivationRequestInputDTO {
        const json = this.toJSON();
        let result = new ReactivationRequestInputDTO();
        result.init(json);
        return result;
    }
}

export interface IReactivationRequestInputDTO {
    username: string;
    serverId: string;
    siteId: number;
    description?: string | undefined;
}

export class RelevantAlertsDTO implements IRelevantAlertsDTO {
    isAuthenticated?: boolean;
    alerts?: SimpleTableauServerAlertDTO[] | undefined;

    constructor(data?: IRelevantAlertsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthenticated = _data["isAuthenticated"];
            if (Array.isArray(_data["alerts"])) {
                this.alerts = [] as any;
                for (let item of _data["alerts"])
                    this.alerts!.push(SimpleTableauServerAlertDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RelevantAlertsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RelevantAlertsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthenticated"] = this.isAuthenticated;
        if (Array.isArray(this.alerts)) {
            data["alerts"] = [];
            for (let item of this.alerts)
                data["alerts"].push(item.toJSON());
        }
        return data;
    }

    clone(): RelevantAlertsDTO {
        const json = this.toJSON();
        let result = new RelevantAlertsDTO();
        result.init(json);
        return result;
    }
}

export interface IRelevantAlertsDTO {
    isAuthenticated?: boolean;
    alerts?: SimpleTableauServerAlertDTO[] | undefined;
}

export class RequestAccessRequestDTO implements IRequestAccessRequestDTO {
    serverId!: string;
    type!: ResourceType;
    resourceId?: number;
    contentURL?: string | undefined;

    constructor(data?: IRequestAccessRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverId = _data["serverId"];
            this.type = _data["type"];
            this.resourceId = _data["resourceId"];
            this.contentURL = _data["contentURL"];
        }
    }

    static fromJS(data: any): RequestAccessRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequestAccessRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverId"] = this.serverId;
        data["type"] = this.type;
        data["resourceId"] = this.resourceId;
        data["contentURL"] = this.contentURL;
        return data;
    }

    clone(): RequestAccessRequestDTO {
        const json = this.toJSON();
        let result = new RequestAccessRequestDTO();
        result.init(json);
        return result;
    }
}

export interface IRequestAccessRequestDTO {
    serverId: string;
    type: ResourceType;
    resourceId?: number;
    contentURL?: string | undefined;
}

export class RequestAccessResponseDTO implements IRequestAccessResponseDTO {
    permissionGroups?: string[] | undefined;

    constructor(data?: IRequestAccessResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissionGroups"])) {
                this.permissionGroups = [] as any;
                for (let item of _data["permissionGroups"])
                    this.permissionGroups!.push(item);
            }
        }
    }

    static fromJS(data: any): RequestAccessResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequestAccessResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissionGroups)) {
            data["permissionGroups"] = [];
            for (let item of this.permissionGroups)
                data["permissionGroups"].push(item);
        }
        return data;
    }

    clone(): RequestAccessResponseDTO {
        const json = this.toJSON();
        let result = new RequestAccessResponseDTO();
        result.init(json);
        return result;
    }
}

export interface IRequestAccessResponseDTO {
    permissionGroups?: string[] | undefined;
}

export enum ResourceType {
    Project = "project",
    Workbook = "workbook",
    View = "view",
}

export class SelfServiceReactivateInputDTO implements ISelfServiceReactivateInputDTO {
    username!: string;
    serverId!: string;
    siteId!: number;

    constructor(data?: ISelfServiceReactivateInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.serverId = _data["serverId"];
            this.siteId = _data["siteId"];
        }
    }

    static fromJS(data: any): SelfServiceReactivateInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServiceReactivateInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["serverId"] = this.serverId;
        data["siteId"] = this.siteId;
        return data;
    }

    clone(): SelfServiceReactivateInputDTO {
        const json = this.toJSON();
        let result = new SelfServiceReactivateInputDTO();
        result.init(json);
        return result;
    }
}

export interface ISelfServiceReactivateInputDTO {
    username: string;
    serverId: string;
    siteId: number;
}

export class ServerAlertScheduleDTO implements IServerAlertScheduleDTO {
    type?: ServerAlertScheduleType;
    show_Start?: string | undefined;
    show_End?: string | undefined;
    fixed_Start?: Date | undefined;
    fixed_End?: Date | undefined;
    weekly_DayOfWeek?: DayOfWeek;
    monthly_Day?: number | undefined;

    constructor(data?: IServerAlertScheduleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.show_Start = _data["Show_Start"];
            this.show_End = _data["Show_End"];
            this.fixed_Start = _data["fixed_Start"] ? new Date(_data["fixed_Start"].toString()) : <any>undefined;
            this.fixed_End = _data["fixed_End"] ? new Date(_data["fixed_End"].toString()) : <any>undefined;
            this.weekly_DayOfWeek = _data["weekly_DayOfWeek"];
            this.monthly_Day = _data["monthly_Day"];
        }
    }

    static fromJS(data: any): ServerAlertScheduleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServerAlertScheduleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["Show_Start"] = this.show_Start;
        data["Show_End"] = this.show_End;
        data["fixed_Start"] = this.fixed_Start ? this.fixed_Start.toISOString() : <any>undefined;
        data["fixed_End"] = this.fixed_End ? this.fixed_End.toISOString() : <any>undefined;
        data["weekly_DayOfWeek"] = this.weekly_DayOfWeek;
        data["monthly_Day"] = this.monthly_Day;
        return data;
    }

    clone(): ServerAlertScheduleDTO {
        const json = this.toJSON();
        let result = new ServerAlertScheduleDTO();
        result.init(json);
        return result;
    }
}

export interface IServerAlertScheduleDTO {
    type?: ServerAlertScheduleType;
    show_Start?: string | undefined;
    show_End?: string | undefined;
    fixed_Start?: Date | undefined;
    fixed_End?: Date | undefined;
    weekly_DayOfWeek?: DayOfWeek;
    monthly_Day?: number | undefined;
}

export enum ServerAlertScheduleType {
    Fixed = "fixed",
    Daily = "daily",
    DayOfWeek = "dayOfWeek",
    DayOfMonth = "dayOfMonth",
}

export class ServerAlertStatisticInputDTO implements IServerAlertStatisticInputDTO {
    alertId!: string;
    type!: ServerAlertStatisticType;
    browserUrl?: string | undefined;
    browserUserAgent?: string | undefined;

    constructor(data?: IServerAlertStatisticInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertId = _data["alertId"];
            this.type = _data["type"];
            this.browserUrl = _data["browserUrl"];
            this.browserUserAgent = _data["browserUserAgent"];
        }
    }

    static fromJS(data: any): ServerAlertStatisticInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServerAlertStatisticInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertId"] = this.alertId;
        data["type"] = this.type;
        data["browserUrl"] = this.browserUrl;
        data["browserUserAgent"] = this.browserUserAgent;
        return data;
    }

    clone(): ServerAlertStatisticInputDTO {
        const json = this.toJSON();
        let result = new ServerAlertStatisticInputDTO();
        result.init(json);
        return result;
    }
}

export interface IServerAlertStatisticInputDTO {
    alertId: string;
    type: ServerAlertStatisticType;
    browserUrl?: string | undefined;
    browserUserAgent?: string | undefined;
}

export enum ServerAlertStatisticType {
    Seen = "seen",
    Dismissed = "dismissed",
}

export class SimpleTableauServerAlertDTO implements ISimpleTableauServerAlertDTO {
    id?: string | undefined;
    contentHtml?: string | undefined;
    backgroundColor?: string | undefined;
    disappearAfterSec?: number;
    dismissableForHours?: number | undefined;
    collectStatistics?: boolean;
    filter_UrlRegexes?: string[] | undefined;
    schedule?: ServerAlertScheduleDTO[] | undefined;

    constructor(data?: ISimpleTableauServerAlertDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contentHtml = _data["contentHtml"];
            this.backgroundColor = _data["backgroundColor"];
            this.disappearAfterSec = _data["disappearAfterSec"];
            this.dismissableForHours = _data["dismissableForHours"];
            this.collectStatistics = _data["collectStatistics"];
            if (Array.isArray(_data["filter_UrlRegexes"])) {
                this.filter_UrlRegexes = [] as any;
                for (let item of _data["filter_UrlRegexes"])
                    this.filter_UrlRegexes!.push(item);
            }
            if (Array.isArray(_data["schedule"])) {
                this.schedule = [] as any;
                for (let item of _data["schedule"])
                    this.schedule!.push(ServerAlertScheduleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimpleTableauServerAlertDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleTableauServerAlertDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contentHtml"] = this.contentHtml;
        data["backgroundColor"] = this.backgroundColor;
        data["disappearAfterSec"] = this.disappearAfterSec;
        data["dismissableForHours"] = this.dismissableForHours;
        data["collectStatistics"] = this.collectStatistics;
        if (Array.isArray(this.filter_UrlRegexes)) {
            data["filter_UrlRegexes"] = [];
            for (let item of this.filter_UrlRegexes)
                data["filter_UrlRegexes"].push(item);
        }
        if (Array.isArray(this.schedule)) {
            data["schedule"] = [];
            for (let item of this.schedule)
                data["schedule"].push(item.toJSON());
        }
        return data;
    }

    clone(): SimpleTableauServerAlertDTO {
        const json = this.toJSON();
        let result = new SimpleTableauServerAlertDTO();
        result.init(json);
        return result;
    }
}

export interface ISimpleTableauServerAlertDTO {
    id?: string | undefined;
    contentHtml?: string | undefined;
    backgroundColor?: string | undefined;
    disappearAfterSec?: number;
    dismissableForHours?: number | undefined;
    collectStatistics?: boolean;
    filter_UrlRegexes?: string[] | undefined;
    schedule?: ServerAlertScheduleDTO[] | undefined;
}

export class SpreadSheetEnabledInputInfoDTO implements ISpreadSheetEnabledInputInfoDTO {
    serverId!: string;

    constructor(data?: ISpreadSheetEnabledInputInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverId = _data["serverId"];
        }
    }

    static fromJS(data: any): SpreadSheetEnabledInputInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpreadSheetEnabledInputInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverId"] = this.serverId;
        return data;
    }

    clone(): SpreadSheetEnabledInputInfoDTO {
        const json = this.toJSON();
        let result = new SpreadSheetEnabledInputInfoDTO();
        result.init(json);
        return result;
    }
}

export interface ISpreadSheetEnabledInputInfoDTO {
    serverId: string;
}

export class SpreadSheetListRequestDTO implements ISpreadSheetListRequestDTO {
    serverId!: string;

    constructor(data?: ISpreadSheetListRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverId = _data["serverId"];
        }
    }

    static fromJS(data: any): SpreadSheetListRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpreadSheetListRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverId"] = this.serverId;
        return data;
    }

    clone(): SpreadSheetListRequestDTO {
        const json = this.toJSON();
        let result = new SpreadSheetListRequestDTO();
        result.init(json);
        return result;
    }
}

export interface ISpreadSheetListRequestDTO {
    serverId: string;
}

export class SpreadSheetResponseDTO implements ISpreadSheetResponseDTO {
    spreadSheetName?: string | undefined;
    spreadSheetId?: string | undefined;
    parents?: string[] | undefined;

    constructor(data?: ISpreadSheetResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spreadSheetName = _data["spreadSheetName"];
            this.spreadSheetId = _data["spreadSheetId"];
            if (Array.isArray(_data["parents"])) {
                this.parents = [] as any;
                for (let item of _data["parents"])
                    this.parents!.push(item);
            }
        }
    }

    static fromJS(data: any): SpreadSheetResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpreadSheetResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spreadSheetName"] = this.spreadSheetName;
        data["spreadSheetId"] = this.spreadSheetId;
        if (Array.isArray(this.parents)) {
            data["parents"] = [];
            for (let item of this.parents)
                data["parents"].push(item);
        }
        return data;
    }

    clone(): SpreadSheetResponseDTO {
        const json = this.toJSON();
        let result = new SpreadSheetResponseDTO();
        result.init(json);
        return result;
    }
}

export interface ISpreadSheetResponseDTO {
    spreadSheetName?: string | undefined;
    spreadSheetId?: string | undefined;
    parents?: string[] | undefined;
}

export class TableauServerDTO implements ITableauServerDTO {
    id?: string | undefined;
    type?: TableauServerType;
    name?: string | undefined;
    description?: string | undefined;
    baseUrl?: string | undefined;
    isPatAuthentication?: boolean;
    user?: string | undefined;
    managing?: boolean;
    added?: Date;
    pgHost?: string | undefined;
    pgPort?: number | undefined;
    emailIntegrationEnabled?: boolean | undefined;
    emailIntegrationAllowEmailChange?: boolean | undefined;
    sheetIntegrationEnabled?: boolean | undefined;
    smtpHost?: string | undefined;
    smtpPort?: number | undefined;
    sslEnabled?: boolean | undefined;
    smtpUser?: string | undefined;
    smtpDomain?: string | undefined;
    timeout?: number | undefined;
    fromEmail?: string | undefined;
    fromName?: string | undefined;

    constructor(data?: ITableauServerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.baseUrl = _data["baseUrl"];
            this.isPatAuthentication = _data["isPatAuthentication"];
            this.user = _data["user"];
            this.managing = _data["managing"];
            this.added = _data["added"] ? new Date(_data["added"].toString()) : <any>undefined;
            this.pgHost = _data["pgHost"];
            this.pgPort = _data["pgPort"];
            this.emailIntegrationEnabled = _data["emailIntegrationEnabled"];
            this.emailIntegrationAllowEmailChange = _data["emailIntegrationAllowEmailChange"];
            this.sheetIntegrationEnabled = _data["sheetIntegrationEnabled"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.sslEnabled = _data["sslEnabled"];
            this.smtpUser = _data["smtpUser"];
            this.smtpDomain = _data["smtpDomain"];
            this.timeout = _data["timeout"];
            this.fromEmail = _data["fromEmail"];
            this.fromName = _data["fromName"];
        }
    }

    static fromJS(data: any): TableauServerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TableauServerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        data["description"] = this.description;
        data["baseUrl"] = this.baseUrl;
        data["isPatAuthentication"] = this.isPatAuthentication;
        data["user"] = this.user;
        data["managing"] = this.managing;
        data["added"] = this.added ? this.added.toISOString() : <any>undefined;
        data["pgHost"] = this.pgHost;
        data["pgPort"] = this.pgPort;
        data["emailIntegrationEnabled"] = this.emailIntegrationEnabled;
        data["emailIntegrationAllowEmailChange"] = this.emailIntegrationAllowEmailChange;
        data["sheetIntegrationEnabled"] = this.sheetIntegrationEnabled;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["sslEnabled"] = this.sslEnabled;
        data["smtpUser"] = this.smtpUser;
        data["smtpDomain"] = this.smtpDomain;
        data["timeout"] = this.timeout;
        data["fromEmail"] = this.fromEmail;
        data["fromName"] = this.fromName;
        return data;
    }

    clone(): TableauServerDTO {
        const json = this.toJSON();
        let result = new TableauServerDTO();
        result.init(json);
        return result;
    }
}

export interface ITableauServerDTO {
    id?: string | undefined;
    type?: TableauServerType;
    name?: string | undefined;
    description?: string | undefined;
    baseUrl?: string | undefined;
    isPatAuthentication?: boolean;
    user?: string | undefined;
    managing?: boolean;
    added?: Date;
    pgHost?: string | undefined;
    pgPort?: number | undefined;
    emailIntegrationEnabled?: boolean | undefined;
    emailIntegrationAllowEmailChange?: boolean | undefined;
    sheetIntegrationEnabled?: boolean | undefined;
    smtpHost?: string | undefined;
    smtpPort?: number | undefined;
    sslEnabled?: boolean | undefined;
    smtpUser?: string | undefined;
    smtpDomain?: string | undefined;
    timeout?: number | undefined;
    fromEmail?: string | undefined;
    fromName?: string | undefined;
}

export enum TableauServerType {
    OnPremise = "onPremise",
    Cloud = "cloud",
}

export class TableauSiteDTO implements ITableauSiteDTO {
    siteId?: number;
    apiSiteId?: string;
    name?: string | undefined;
    contentUrl?: string | undefined;

    constructor(data?: ITableauSiteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.apiSiteId = _data["apiSiteId"];
            this.name = _data["name"];
            this.contentUrl = _data["contentUrl"];
        }
    }

    static fromJS(data: any): TableauSiteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TableauSiteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["apiSiteId"] = this.apiSiteId;
        data["name"] = this.name;
        data["contentUrl"] = this.contentUrl;
        return data;
    }

    clone(): TableauSiteDTO {
        const json = this.toJSON();
        let result = new TableauSiteDTO();
        result.init(json);
        return result;
    }
}

export interface ITableauSiteDTO {
    siteId?: number;
    apiSiteId?: string;
    name?: string | undefined;
    contentUrl?: string | undefined;
}

export class TokenInfoDTO implements ITokenInfoDTO {
    userName?: string | undefined;
    email?: string | undefined;

    constructor(data?: ITokenInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): TokenInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TokenInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        return data;
    }

    clone(): TokenInfoDTO {
        const json = this.toJSON();
        let result = new TokenInfoDTO();
        result.init(json);
        return result;
    }
}

export interface ITokenInfoDTO {
    userName?: string | undefined;
    email?: string | undefined;
}

export class UnlicensedSiteDTO implements IUnlicensedSiteDTO {
    site?: TableauSiteDTO;
    oldRole?: SiteRoleType;
    recommendedRole?: SiteRoleType;
    disabledOn?: Date | undefined;
    reactivateMode?: ReactivateMode;

    constructor(data?: IUnlicensedSiteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.site = _data["site"] ? TableauSiteDTO.fromJS(_data["site"]) : <any>undefined;
            this.oldRole = _data["oldRole"];
            this.recommendedRole = _data["recommendedRole"];
            this.disabledOn = _data["disabledOn"] ? new Date(_data["disabledOn"].toString()) : <any>undefined;
            this.reactivateMode = _data["reactivateMode"];
        }
    }

    static fromJS(data: any): UnlicensedSiteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UnlicensedSiteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["site"] = this.site ? this.site.toJSON() : <any>undefined;
        data["oldRole"] = this.oldRole;
        data["recommendedRole"] = this.recommendedRole;
        data["disabledOn"] = this.disabledOn ? this.disabledOn.toISOString() : <any>undefined;
        data["reactivateMode"] = this.reactivateMode;
        return data;
    }

    clone(): UnlicensedSiteDTO {
        const json = this.toJSON();
        let result = new UnlicensedSiteDTO();
        result.init(json);
        return result;
    }
}

export interface IUnlicensedSiteDTO {
    site?: TableauSiteDTO;
    oldRole?: SiteRoleType;
    recommendedRole?: SiteRoleType;
    disabledOn?: Date | undefined;
    reactivateMode?: ReactivateMode;
}

export class UnlicensedSitesInputDTO implements IUnlicensedSitesInputDTO {
    username!: string;
    serverId!: string;

    constructor(data?: IUnlicensedSitesInputDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.serverId = _data["serverId"];
        }
    }

    static fromJS(data: any): UnlicensedSitesInputDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UnlicensedSitesInputDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["serverId"] = this.serverId;
        return data;
    }

    clone(): UnlicensedSitesInputDTO {
        const json = this.toJSON();
        let result = new UnlicensedSitesInputDTO();
        result.init(json);
        return result;
    }
}

export interface IUnlicensedSitesInputDTO {
    username: string;
    serverId: string;
}

export class UnlicensedSitesResponseDTO implements IUnlicensedSitesResponseDTO {
    autoReactivated?: boolean;
    showSingleButtonToSelfActivate?: boolean;
    sites?: UnlicensedSiteDTO[] | undefined;

    constructor(data?: IUnlicensedSitesResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autoReactivated = _data["autoReactivated"];
            this.showSingleButtonToSelfActivate = _data["showSingleButtonToSelfActivate"];
            if (Array.isArray(_data["sites"])) {
                this.sites = [] as any;
                for (let item of _data["sites"])
                    this.sites!.push(UnlicensedSiteDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnlicensedSitesResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UnlicensedSitesResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autoReactivated"] = this.autoReactivated;
        data["showSingleButtonToSelfActivate"] = this.showSingleButtonToSelfActivate;
        if (Array.isArray(this.sites)) {
            data["sites"] = [];
            for (let item of this.sites)
                data["sites"].push(item.toJSON());
        }
        return data;
    }

    clone(): UnlicensedSitesResponseDTO {
        const json = this.toJSON();
        let result = new UnlicensedSitesResponseDTO();
        result.init(json);
        return result;
    }
}

export interface IUnlicensedSitesResponseDTO {
    autoReactivated?: boolean;
    showSingleButtonToSelfActivate?: boolean;
    sites?: UnlicensedSiteDTO[] | undefined;
}

export class UpdateSpreadSheetDataResponseDTO implements IUpdateSpreadSheetDataResponseDTO {
    fileId?: string | undefined;

    constructor(data?: IUpdateSpreadSheetDataResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): UpdateSpreadSheetDataResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSpreadSheetDataResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        return data;
    }

    clone(): UpdateSpreadSheetDataResponseDTO {
        const json = this.toJSON();
        let result = new UpdateSpreadSheetDataResponseDTO();
        result.init(json);
        return result;
    }
}

export interface IUpdateSpreadSheetDataResponseDTO {
    fileId?: string | undefined;
}

export class UpdateSpreadSheetRequestDTO implements IUpdateSpreadSheetRequestDTO {
    serverId!: string;
    spreadSheetId!: string;
    sheetName!: string;
    data!: string[][];

    constructor(data?: IUpdateSpreadSheetRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverId = _data["serverId"];
            this.spreadSheetId = _data["spreadSheetId"];
            this.sheetName = _data["sheetName"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSpreadSheetRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSpreadSheetRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverId"] = this.serverId;
        data["spreadSheetId"] = this.spreadSheetId;
        data["sheetName"] = this.sheetName;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }

    clone(): UpdateSpreadSheetRequestDTO {
        const json = this.toJSON();
        let result = new UpdateSpreadSheetRequestDTO();
        result.init(json);
        return result;
    }
}

export interface IUpdateSpreadSheetRequestDTO {
    serverId: string;
    spreadSheetId: string;
    sheetName: string;
    data: string[][];
}

export class WalkMeScriptDTO implements IWalkMeScriptDTO {
    hasWalkMeIntegration?: boolean;
    walkMeScript?: string | undefined;

    constructor(data?: IWalkMeScriptDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasWalkMeIntegration = _data["hasWalkMeIntegration"];
            this.walkMeScript = _data["walkMeScript"];
        }
    }

    static fromJS(data: any): WalkMeScriptDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WalkMeScriptDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasWalkMeIntegration"] = this.hasWalkMeIntegration;
        data["walkMeScript"] = this.walkMeScript;
        return data;
    }

    clone(): WalkMeScriptDTO {
        const json = this.toJSON();
        let result = new WalkMeScriptDTO();
        result.init(json);
        return result;
    }
}

export interface IWalkMeScriptDTO {
    hasWalkMeIntegration?: boolean;
    walkMeScript?: string | undefined;
}

export enum SiteRoleType {
    Creator = "creator",
    Explorer = "explorer",
    ExplorerCanPublish = "explorerCanPublish",
    Guest = "guest",
    Interactor = "interactor",
    Publisher = "publisher",
    ReadOnly = "readOnly",
    ServerAdministrator = "serverAdministrator",
    SiteAdministrator = "siteAdministrator",
    SiteAdministratorCreator = "siteAdministratorCreator",
    SiteAdministratorExplorer = "siteAdministratorExplorer",
    Unlicensed = "unlicensed",
    UnlicensedWithPublish = "unlicensedWithPublish",
    Viewer = "viewer",
    ViewerWithPublish = "viewerWithPublish",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}